const Header = () => {
    return (
        <div className='header'>
            <h1> Roman Numeral Converter</h1>
            <h2 className='explain'>Type in an arabic number (1, 2, 3,...) up to the thousands place and hit 'Submit' to get its roman numeral equivalent!</h2>
        </div>
    )
}

export default Header


